import { Component, type ReactNode } from 'react';

// Minimal error boundary so one component's render failure can't take down its siblings.
// Used to isolate the additive Learning Loop grid from the preserved macro band.
export default class ErrorBoundary extends Component<{ fallback: ReactNode; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    // Swallow: the fallback renders in place; sibling components are unaffected.
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
